import { LinkedTagListCell } from "../../../components/molecules/Table/Cell";
import { uniqueNamedItems } from "../../../helper/uniqueNamedItems";

export function getPrepaymentPurchaseOrders(order) {
  const { allocations, purchase_orders: purchaseOrders } = order || {};
  const fromAllocations = uniqueNamedItems((allocations ?? []).map(item => item.purchase_order));

  if (fromAllocations.length) {
    return fromAllocations;
  }

  return uniqueNamedItems(purchaseOrders);
}

export function PrepaymentPurchaseOrdersCell({ order, width = 100 }) {
  return (
    <LinkedTagListCell
      items={getPrepaymentPurchaseOrders(order)}
      getTo={po => `/orders/purchase/${po.id}`}
      width={width}
    />
  );
}
